import { ListeningOwnership, useListeningModeStore } from '../listeningModeStore';

export const setListeningModeOwnership = (ownership: ListeningOwnership) => {
  useListeningModeStore.setState({ ownership });
};
